namespace Shared.Infrastructure

open System

[<RequireQualifiedAccess>]
module DateTime =
    let toString (format: String) (dateTime: DateTime) = dateTime.ToString(format)

    let toDateTimeString (dateTime: DateTime) = toString "dd.MM.yyyy HH:mm:ss" dateTime

    let toSortableDateTimeString (dateTime: DateTime) = toString "yyyy.MM.dd HH:mm:ss" dateTime

    let toShortString (dateTime: DateTime) = toString "dd.MM.yy HH:mm" dateTime

    let toDateString (dateTime: DateTime) = toString "dd.MM.yyyy" dateTime

    let toDateFileNameString (dateTime: DateTime) = toString "yyyyMMdd" dateTime

    let toDayMonthString (dateTime: DateTime) = toString "dd.MM." dateTime

    let toTimeString (time: DateTime) = toString "HH:mm" time

    let startOfDay (dateTime: DateTime) : DateTime = dateTime.Date

    let endOfDay (dateTime: DateTime) : DateTime =
        DateTime(dateTime.Year, dateTime.Month, dateTime.Day, 23, 59, 59, dateTime.Kind)

    let addMinutes (minutes: int) (date: DateTime) = date.AddMinutes(float minutes)

    let addHours (hours: int) (date: DateTime) = date.AddHours(float hours)

    let addDays (days: int) (date: DateTime) = date.AddDays(float days)

    let removeDays (days: int) (date: DateTime) = addDays (-days) date

    let addMonths (months: int) (date: DateTime) = date.AddMonths(months)

    let removeMonths (months: int) (date: DateTime) = addMonths (-months) date

    let addYears (years: int) (date: DateTime) = date.AddYears(years)

    let removeYears (years: int) (date: DateTime) = addYears (-years) date